// extracted by mini-css-extract-plugin
module.exports = {"MediaBlock":"dLPZj","MediaBlock__WrapSingle_theme_dark":"JhcOW","MediaBlockTitle":"tr5XZ","MediaBlockTitle_accent":"IVb9d","MediaBlockContainer":"V8NVa","MediaBlockSlider":"zlGwi"};